import { snackbarService } from "~/components/SnackbarStack";
import { log } from "~/utils/log";

export interface LogErrorProps {
  readonly error: any;
  readonly logTag: string;
  readonly defaultErrorMessage: string;
}

const TECHNICAL_MESSAGE_PATTERNS = [
  /^[A-Z_]+$/, // Códigos como "INTERNAL_ERROR"
  /undefined|null|TypeError|ReferenceError|SyntaxError/i,
  /^\[object/,
  /stack trace/i,
  /cannot read propert/i,
  /is not a function/i,
  /is not defined/i,
  /network error/i,
  /failed to fetch/i,
  /ERR_/i,
];

function isTechnicalMessage(message: string): boolean {
  return TECHNICAL_MESSAGE_PATTERNS.some((pattern) => pattern.test(message));
}

export function logError({ error, logTag, defaultErrorMessage }: LogErrorProps) {
  log.e(logTag, error);

  if (error?.response && error.response?.status >= 500) {
    return snackbarService.showSnackbar(defaultErrorMessage, "error");
  }

  if (error?.message && !isTechnicalMessage(error.message)) {
    snackbarService.showSnackbar(error.message, "error");
  } else {
    snackbarService.showSnackbar(defaultErrorMessage, "error");
  }
}
